import React from 'react';
import { View, TouchableOpacity, StyleSheet, Image } from 'react-native';
import moment from 'moment';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import { formatCurrency } from '../../utils/currency.utils';
import BaseText from '../BaseText';
import Icon from '../Icon';
import RowView from '../RowView';
import { scale } from '../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../i18n';
import { selectCompanyCurrencyCulture } from '../../store/selectors/auth.selector';
import { useSelector } from 'react-redux';
import { getRangeDate, hasIncompleteMandatoryFields } from '../../utils/expense.utils';

const ExpenseReportCardInfo = ({ style, item, onEditName }) => {
  const { t } = useTranslation(i18nNS.tripExpense);
  const { tKey } = useComponentTKey('ExpenseScreen');
  const currency =
    (item?.Expenses && item.Expenses.length > 0 && item.Expenses[0]?.Currency) || 'USD';
  const currencyCulture = useSelector(selectCompanyCurrencyCulture);
  const showExclamationIcon = item?.Expenses?.some((expense) =>
    hasIncompleteMandatoryFields(expense)
  );
  return (
    <View style={[CommonStyles.flex1, style]}>
      <RowView style={styles.header}>
        <BaseText style={styles.title}>
          {item?.Name.length > 30 ? `${item?.Name.substring(0, 30)}...` : item?.Name}
        </BaseText>
        {onEditName ? (
          <TouchableOpacity onPress={onEditName}>
            <Icon name="edit" size={18} color={Color.primary} />
          </TouchableOpacity>
        ) : null}
        <BaseText style={styles.title}>
          {' - '}
          {item?.ReportNumber}
        </BaseText>
      </RowView>

      <RowView style={styles.element}>
        <BaseText style={[styles.status, styles[item.Status]]}>
          {item.Expenses ? item.Expenses.length : 0} {t(`ExpenseReportState.${item.Status}`)}
        </BaseText>
        <BaseText style={[CommonStyles.h2, styles.priceTextStyle]}>
          {formatCurrency(item.ReportCost, currency, currencyCulture, 2)}
        </BaseText>
      </RowView>

      <RowView style={styles.footer}>
        <BaseText style={[CommonStyles.h4, { color: Color.text.medium }]}>
          {getRangeDate(item, 'MMM DD YYYY', t(tKey('To')))}
        </BaseText>
        {showExclamationIcon && (
          <Image
            source={require('../../assets/images/exclamation-icon.png')}
            style={styles.exclamationIconStyle}
          />
        )}
      </RowView>
    </View>
  );
};

const styles = StyleSheet.create({
  status: {
    color: Color.accent,
    textAlign: 'center',
    backgroundColor: Color.tezNewBlue,
    width: scale(80),
    height: scale(18),
    overflow: 'hidden',
    ...CommonProperties.xSmall,
    ...CommonProperties.borderRadius2,
    ...CommonProperties.py1,
  },
  element: {
    justifyContent: 'space-between',
    width: '100%',
    ...CommonProperties.mt3,
    alignItems: 'center',
  },
  title: {
    ...CommonProperties.h4,
    ...CommonProperties.mr3,
  },
  header: {
    justifyContent: 'flex-start',
    width: '100%',
    alignItems: 'center',
  },
  footer: {
    justifyContent: 'space-between',
    alignItems: 'center',
    ...CommonProperties.mt3,
  },
  exclamationIconStyle: {
    width: 30,
    height: 30,
    alignSelf: 'flex-end',
  },
  priceTextStyle: {
    alignSelf: 'flex-end',
  },
});

export default ExpenseReportCardInfo;
